<template>
    <CardRh :processando="processando">
        <div class="turma-vf-page">
            <section class="filter-panel">
                <span class="panel-border-label">Filtros</span>

                <div class="row g-4">
                    <div class="col-12 col-md-6 col-lg-4">
                        <label for="searchVfTurma" class="form-label">Pesquisar</label>
                        <input id="searchVfTurma" v-model="search" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pesquisar" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-3">
                        <label for="pelotaoVfTurma" class="form-label">Pelotao</label>
                        <input id="pelotaoVfTurma" v-model="pelotao" @keyup="apertouEnter" type="text"
                            class="form-control form-control-solid" placeholder="Pelotao" />
                    </div>

                    <div class="col-12 col-md-6 col-lg-5 panel-actions">
                        <button type="button" class="btn btn-pmes-warning btn-sm" @click="limparFiltros">
                            Limpar filtros
                        </button>
                    </div>
                </div>
            </section>

            <section class="table-panel">
                <KDataTable :reload="reloadDatatable" :config="config" @tableatualizada="tableatualizada($event)"
                    :pesquisar="false">
                    <th>Nome</th>
                    <th>Pelotao</th>
                    <th>Quantidade</th>
                    <th style="min-width:130px" class="text-center" v-if="hasPermissao">Acoes</th>
                </KDataTable>
            </section>
        </div>
    </CardRh>
</template>

<script lang="ts">
import IndexModelTable from '@/views/paginas/sigap/modelos/IndexModelTable.vue';
import CardRh from "@/components/cards/ManzaCard.vue";
import MatriculaService from "@/service/v1/sigap/MatriculaService";
import { Options } from "vue-class-component";
import SiteUtils from '@/assets/ts/aplicacao/site';
import KDataTable from "@/components/datatable/newdatatable.vue";
import $ from "jquery";
import { PerfilConfig } from "@/core/config/PerfisConfig";

@Options({
    name: "QuantidadeVFIndex",
    components: { CardRh, KDataTable },
})
export default class QuantidadeVFIndex extends IndexModelTable {
    public turmaId: any = null;
    public aluno_id: any = null;
    public modal_visualizar: any = 'modal_visualizar_turma_vf_aluno';
    public search = '';
    public pelotao = '';

    get hasPermissao(): boolean {
        return SiteUtils.hasPermissao([PerfilConfig.Admin, PerfilConfig.ChefeSTE, PerfilConfig.AuxSTE], this.perfis);
    }

    public refreshTable() {
        setTimeout(() => {
            this.reloadDatatable = !this.reloadDatatable;
        }, 300);
    }

    public apertouEnter(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            this.refreshTable();
        }
    }

    public limparFiltros() {
        this.search = '';
        this.pelotao = '';
        this.refreshTable();
    }

    created() {
        this.service = new MatriculaService();
        this.turmaId = this.$route.params.id;
        this.config.ajax = {
            url: this.service.getApiUrl() + '/VerificacaoFinal',
            data: (d) => {
                const dados = {
                    Skip: d.start,
                    Take: d.length,
                    turmaId: this.turmaId,
                    pelotao: this.pelotao,
                    search: this.search,
                };
                return dados;
            }
        };
        this.config.order = [[0, 'asc']];
        this.config.columns = [
            { data: 'usuario.nome', name: 'usuario' },
            { data: 'pelotao', name: 'pelotao', class: 'text-center' },
            { data: 'quantidadeVF', name: 'quantidadeVF', class: 'text-center', searchable: false },
        ];
        if (this.hasPermissao) {
            this.pushColunaAcoes();
            this.config.columnDefs = [
                {
                    targets: 3,
                    render: (row, type, val) => {
                        let texto = '';
                        let buttom = '';
                        for (const key in val) {
                            buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                        }
                        texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-show-vf-aluno ' + buttom + ' title="Visualizar"><i class="fa fa-eye"></i></button>';
                        return texto;
                    },
                },
            ];
        }
    }

    public tableatualizada() {
        $('[btn-show-vf-aluno]').click((btn) => {
            const id = $(btn.currentTarget).data('id');
            window.open('/#/sigap/matricula/' + id + '/vf', '_blank');
        });
    }
}
</script>

<style scoped>
.turma-vf-page {
    display: grid;
    gap: 24px;
}

.filter-panel,
.table-panel {
    border: 1px solid #e5edf6;
    border-radius: 22px;
    background: linear-gradient(180deg, #ffffff 0%, #f9fbfd 100%);
    padding: 15px;
}

.filter-panel {
    position: relative;
    padding-top: 24px;
}

.panel-border-label {
    position: absolute;
    top: -9px;
    left: 18px;
    padding: 0 10px;
    background: #ffffff;
    color: #102542;
    font-size: 0.95rem;
    font-weight: 800;
    line-height: 1.4;
}

.table-panel {
    padding: 2px 10px !important;
}

.panel-actions {
    text-align: end;
    margin-top: 20px;
}

.btn-sm {
    margin-left: 10px;
}

.registro-alteracao {
    text-align: right;
}

@media screen and (max-width: 991px) {

    .filter-panel,
    .table-panel {
        padding: 18px;
        border-radius: 18px;
    }

    .filter-panel {
        padding-top: 26px;
    }

    .panel-actions {
        text-align: left;
        margin-top: 0;
    }
}
</style>
